import React from 'react'

import { SiShopify, SiStripe } from '@icons-pack/react-simple-icons'

// VERA-873: brand glyphs for the "Open in" external-tools menu. Real official
// marks from simple-icons (Shopify/Stripe), rendered monochrome via
// `currentColor` so they inherit the menu text colour.
//
// Apollo.io is NOT in simple-icons (it only ships "Apollo GraphQL", a different
// company), so Apollo uses a neutral generic mark — swap for an official
// apollo.io SVG if/when one is added to the asset set.
const SIZE = 18

export const BRAND_ICONS: Record<string, React.ReactNode> = {
  apollo: (
    <svg width={SIZE} height={SIZE} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g stroke="currentColor" strokeWidth="2" strokeLinecap="round">
        <line x1="12" y1="2" x2="12" y2="22" />
        <line x1="2" y1="12" x2="22" y2="12" />
        <line x1="5" y1="5" x2="19" y2="19" />
        <line x1="19" y1="5" x2="5" y2="19" />
      </g>
    </svg>
  ),
  shopify: <SiShopify size={SIZE} color="currentColor" />,
  stripe: <SiStripe size={SIZE} color="currentColor" />,
}
